// extracted by mini-css-extract-plugin
export default {"discountPrice":"Price-discountPrice__pEwp"};